import { render, staticRenderFns } from "./TanyaDoctor.vue?vue&type=template&id=271d5e9d&"
import script from "./TanyaDoctor.vue?vue&type=script&lang=js&"
export * from "./TanyaDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports